module.exports = "https://static.energy5.com/_next/static/images/cert5-ea91ad114f4af18f2f2c7da4f329c05d.png";